import { TeaserItem } from 'designsystem/components/3-organisms/TeaserModule';
import { ConvertToPictureObject } from 'designsystem/utilities/convertToPictureObject';
import { ModuleFeature } from '../DynamicModule';
import { LinkFeature } from '../Link';
import { VideoFeature } from '../Video';

export const TeaserItemFeature: React.FC<Content.TeaserItem> = ({ content, settings }) => {
	const { heading, picture, entryId, videoUrl, text, link, urlWrapperLink } = content?.properties ?? {};
	const { style, imageDisplayStyle } = settings?.properties ?? {};
	const linkDetails = link?.[0];

	const pictureObject = ConvertToPictureObject(picture);

	return (
		<TeaserItem
			heading={heading}
			picture={pictureObject}
			video={
				(videoUrl || entryId) && (
					<VideoFeature
						content={{ properties: { url: videoUrl, entryId: entryId, title: heading } }}
						settings={{ properties: { aspectRatio: '16:9' } }}
						noBackground={true}
					/>
				)
			}
			imageDisplayStyle={imageDisplayStyle}
			imagePosition="Top"
			modals={
				content?.properties.modals?.items.map((modal) => {
					const { modalId, header, body } = modal?.content?.properties ?? {};
					return {
						modalId,
						header,
						body: body?.items.map((contentModule, index) => {
							return <ModuleFeature contentModule={contentModule} key={index} additionalProps={{ noBackground: true }} />;
						}),
					};
				}) ?? []
			}
			text={text?.markup}
			link={linkDetails && <LinkFeature style="arrow" {...linkDetails} />}
			urlWrapperLink={urlWrapperLink}
			backgroundStyle={style}
			style="contained"
		/>
	);
};
